// extracted by mini-css-extract-plugin
export var button = "_61-4";
export var hasDarkBackground = "_61-7";
export var hasLightBackground = "_61-6";
export var iconWrapper = "_61-0";
export var large = "_61-2";
export var medium = "_61-1";
export var small = "_61-5";
export var xsmall = "_61-3";